// components/partial/DepositModal.jsx
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { HTTPService } from '../../services/httpService';

const API = new HTTPService();

class DepositModal extends Component {
  state = {
    depositAmount: 0,
    depositStatus: 'loading',
    depositPayments: [],
    creatingInvoice: false
  };

  async componentDidMount() {
    if (this.props.show && this.props.request) {
      await this.loadDepositInfo();
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show && this.props.request) {
      await this.loadDepositInfo();
    }
  }

  loadDepositInfo = async () => {
    const { request } = this.props;
    
    // Set current deposit amount
    this.setState({ depositAmount: request.depositAmount || 0 });
    
    // Load payment status
    try {
      const { data: payments } = await API.get(`/installerPaymentsRequest/${request.requestId}`);
      const deposits = payments.filter(p => p.payment_type === 'deposit');
      
      let status = 'none';
      if (deposits.length > 0) {
        status = deposits.some(d => d.payment_state === 'paid') ? 'paid' : 'invoiced';
      }
      
      this.setState({ 
        depositPayments: deposits,
        depositStatus: status
      });
    } catch (error) {
      console.error('Error loading deposit info:', error);
      this.setState({ depositStatus: 'error' });
    }
  };

  handleAmountChange = (e) => {
    const amount = parseFloat(e.target.value) || 0;
    const maxAmount = this.props.request?.requestTotal || 0;
    
    // Prevent amount greater than job total
    if (amount <= maxAmount) {
      this.setState({ depositAmount: amount });
    }
  };

  handleSaveAmount = async () => {
  
  try {
    await this.props.onSaveDeposit(this.props.request, this.state.depositAmount);
    this.props.onHide();
    
    if (this.state.depositAmount > 0) {
      alert(`Deposit amount set to $${this.state.depositAmount}. Invoice will be created when you book the job.`);
    }
    
  } catch (error) {
    alert('Error saving deposit amount');
    console.error('Error saving deposit:', error);
  }
  
};

  handleRemoveDeposit = () => {
    if (this.state.depositPayments.length > 0) {
      alert('Cannot remove deposit - invoices already created. Contact support if needed.');
      return;
    }
    
    if (window.confirm('Remove deposit requirement from this job?')) {
      this.setState({ depositAmount: 0 });
    }
  };

  render() {
    const { show, onHide, request } = this.props;
    const { depositAmount, depositStatus, depositPayments } = this.state;

    if (!request) return null;

    const totalPaid = depositPayments
      .filter(p => p.payment_state === 'paid')
      .reduce((sum, p) => sum + p.payment_amount, 0);

    const hasInvoices = depositPayments.length > 0;

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Deposit Value
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          <div className="job-info mb-3 p-3 bg-light rounded">
            <h6 className="mb-1">{request.vehicleYear} {request.vehicleMake} {request.vehicleModel}</h6>
            <p className="text-muted mb-1">{request.serviceRequested}</p>
            <p className="mb-0"><strong>Job Total: ${request.requestTotal?.toFixed(2)}</strong></p>
          </div>

          {/* Deposit Amount Input */}
          <div className="form-group">
            <label htmlFor="depositAmount">
              <strong>Deposit Amount</strong>
              {depositAmount > 0 && (
                <span className="ml-2">
                  ({((depositAmount / request.requestTotal) * 100).toFixed(0)}% of job)
                </span>
              )}
            </label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">$</span>
              </div>
              <input
                type="number"
                className="form-control"
                id="depositAmount"
                value={depositAmount || ''}
                onChange={this.handleAmountChange}
                placeholder="0.00"
                min="0"
                max={request.requestTotal}
                step="0.01"
                disabled={hasInvoices}
              />
            </div>
            <small className="form-text text-muted">
              {hasInvoices ? 
                'Cannot change amount - deposit invoices already created' :
                `Enter deposit amount (max: $${request.requestTotal?.toFixed(2)})`
              }
            </small>
            
            {depositAmount > 0 && !hasInvoices && (
              <button 
                className="btn btn-link btn-sm p-0 mt-1 text-danger"
                onClick={this.handleRemoveDeposit}
              >
                Remove deposit amount
              </button>
            )}
          </div>

          {/* Deposit Status Display */}
          {depositStatus === 'invoiced' && (
            <div className="alert alert-info">
              <strong>Status:</strong> Deposit invoice has been sent to customer
            </div>
          )}

          {depositStatus === 'paid' && (
            <div className="alert alert-success">
              <strong>Status:</strong> Deposit has been paid (${totalPaid.toFixed(2)})
            </div>
          )}

          {depositStatus === 'error' && (
            <div className="alert alert-warning">
              <strong>Status:</strong> Unable to load deposit information
            </div>
          )}
        </Modal.Body>
        
<Modal.Footer>
  <div className="d-flex justify-content-between w-100">
    <div>
      {depositStatus === 'invoiced' && (
        <div className="text-success">
          <small>Deposit invoice created</small>
        </div>
      )}
      
      {depositStatus === 'paid' && (
        <div className="text-success">
          <small>Deposit has been paid</small>
        </div>
      )}
    </div>
    
    <div>
      <Button variant="secondary" onClick={onHide} className="mr-2">
        Cancel
      </Button>
      <Button 
        variant="success" 
        onClick={this.handleSaveAmount}
      >
          Save Deposit Amount
      </Button>
    </div>
  </div>
</Modal.Footer>
        <style jsx>{`
          .payment-history .table th {
            border-top: none;
            font-size: 0.875rem;
          }
          
          .payment-history .table td {
            font-size: 0.875rem;
            vertical-align: middle;
          }
          
          .job-info {
            border-left: 4px solid #007bff;
          }
          
          .alert {
            margin-bottom: 1rem;
          }
          
          .alert:last-child {
            margin-bottom: 0;
          }
        `}</style>
      </Modal>
    );
  }
}

export default DepositModal;